import { MiDialogOptions } from '@/components/MiDialog/MiDialog';
import MiForm, { MiFormField } from '@/components/MiForm/MiForm';
import { User } from '@/models/User';
import ErrorHandler from '@/support/ErrorHandler';
import { AxiosError } from 'axios';
import { Component, Model, Vue } from 'vue-property-decorator';

@Component<Feedback>({})
export default class Feedback extends Vue {
  @Model('user', { default: () => new User() })
  protected user!: User;

  protected $pageTitle = 'Acties';

  protected isChangingPassword = false;

  protected passwordErrorMessage = '';

  protected passwordValid = false;

  protected passwordSaved = false;

  protected async resetPassword(): Promise<void> {
    if (! this.user || ! this.$route.params.id) {
      return;
    }

    const data = await (this.$refs.resetPasswordForm as MiForm).parseFromData();

    const payload: PasswordPayload = { password: data.password };
    await this.user.update(payload)
      .then(() => {
        this.isChangingPassword = false;
        this.passwordValid = false;
        this.passwordSaved = true;
        setTimeout(() => {
          this.passwordSaved = false;
        }, 2000);
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected async validatePassword(): Promise<void> {
    const passwordForm = this.$refs.resetPasswordForm as MiForm;

    if (! passwordForm) {
      this.passwordValid = false;
      return;
    }

    const data = await passwordForm.parseFromData();

    if (! data.password || ! data.confirm_password) {
      this.passwordValid = false;
      return;
    }

    if (data.password && data.confirm_password && (data.password !== data.confirm_password)) {
      this.passwordErrorMessage = 'Wachtwoorden komen niet overeen';
      this.passwordValid = false;
      return;
    }

    if (data.password === data.confirm_password) {
      this.passwordErrorMessage = '';
      this.passwordValid = true;
    }
  }

  protected deleteMfaToken(): void {
    this.$store.dispatch('openDialog', this.mfaDialogOptions);
  }

  protected deleteMfaRequest(): void {
    if (! this.user) return;
    new User()
      .deleteMfa(this.user.uuid)
      .then(() => {
        // this.initialize();
        // this.isEditing = false;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected get mfaDialogOptions(): MiDialogOptions {
    return {
      title: 'Bevestiging',
      text: 'Weet u zeker dat uw de ingestelde MFA token van deze gebruiker will verwijderen. Volgende keer als de gebruiker probeert in te loggen moet hij/zij hun token opnieuw instellen.',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Verwijder',
          color: 'error',
          action: () => {
            this.deleteMfaRequest();
          },
        },
        cancel: {
          text: 'Annuleren',
          color: 'text-light',
          action: () => {},
        },
      },
    };
  }

  protected get passwordButtonText(): string {
    if (this.passwordSaved) {
      return 'Wachtwoord gewijzigd';
    }

    return 'Wachtwoord wijzigen';
  }

  protected get passwordButtonIcon(): string {
    if (this.isChangingPassword && ! this.passwordSaved) {
      return 'mdi-close';
    }

    if (this.passwordSaved) {
      return 'mdi-check';
    }

    return 'mdi-lock';
  }

  protected get resetPasswordFields(): MiFormField[] {
    if (! this.user) {
      return [];
    }

    return [
      {
        type: 'password',
        key: 'password',
        placeholder: 'Wachtwoord',
        label: 'Wachtwoord',
        rules: ['required', 'lengthMinimum8'],
      },
      {
        type: 'password',
        key: 'confirm_password',
        placeholder: 'Wachtwoord bevestigen',
        label: 'Wachtwoord bevestigen',
        rules: ['required'],
      },
    ];
  }
}

interface PasswordPayload {
  password: string;
}
